import type { Locale } from "@/lib/i18n";
import { pl, type WShopBestsellerProductsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wShopBestsellerProductsTranslations: Record<
  Locale,
  WShopBestsellerProductsTranslations
> = {
  pl,
  en,
  de,
};

export type { WShopBestsellerProductsTranslations };
